import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AddAdmin = () => {
    const navigate = useNavigate();

    // Form state management
    const [formData, setFormData] = useState({
        email: "",
        privilege: "employee"
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            const response = await fetch("/api/admin", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.text();
                throw new Error(errorData || "Failed to add admin/employee");
            }

            navigate("/admin-list");
        } catch (err) {
            setError(err.message);
            if (err.message.includes("Access denied")) {
                setError("You don't have permission to add new admins/employees.");
            }
        } finally {
            setLoading(false);
        }
    };

    // Validate required fields
    const isFormValid = () => {
        return formData.email.trim() !== "" && formData.privilege.trim() !== "";
    };

    return (
        <div className="p-8 min-h-screen" style={{ background: 'linear-gradient(to bottom, #b3e672 10%, #7ba02d 90%)' }}>
            <div className="max-w-2xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-white">Add New Admin/Employee</h2>
                </div>

                {error && (
                    <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-700">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-6 space-y-6">
                    <div className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Email *
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Role *
                            </label>
                            <select
                                name="privilege"
                                value={formData.privilege}
                                onChange={handleChange}
                                required
                                className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="employee">Employee</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>

                        <div className="text-sm text-gray-600">
                            Note: To get access to the newly created account, go to forgot password and write your email
                        </div>
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button
                            type="button"
                            onClick={() => navigate("/admin-list")}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={!isFormValid() || loading}
                            className={`px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 
                                ${isFormValid() && !loading
                                    ? "bg-blue-500 hover:bg-blue-600"
                                    : "bg-blue-300 cursor-not-allowed"}`}
                        >
                            {loading ? "Adding..." : "Add Admin/Employee"}
                        </button>
                    </div>
                </form>

                <div className="mt-4 text-sm text-white">
                    * Required fields
                </div>
            </div>
        </div>
    );
};

export default AddAdmin;